import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { BlueprintGrid } from "../components/BlueprintGrid";
import { fadeUp, fadeUpSlow, stagger, viewportOnce } from "../lib/motion";

const ProfClosing = () => (
    <section
        data-testid="prof-closing"
        className="relative overflow-hidden border-t border-white/10 bg-surface/40 py-28 lg:py-44"
    >
        <BlueprintGrid className="opacity-40" />
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <motion.p
                    variants={fadeUp}
                    className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    FOR PROFESSIONALS
                </motion.p>
                <motion.h2
                    variants={fadeUpSlow}
                    data-testid="prof-closing-headline"
                    className="mt-10 max-w-5xl text-4xl font-light leading-[1.1] text-white md:text-6xl lg:text-7xl"
                >
                    Apply to join
                    <span className="block text-mist">
                        the BuildEase network.
                    </span>
                </motion.h2>
                <motion.div
                    variants={fadeUp}
                    className="mt-14 flex flex-wrap items-center gap-x-9 gap-y-5"
                >
                    <Link
                        to="/join-the-pilot"
                        data-testid="prof-apply"
                        className="inline-flex items-center gap-3 bg-accent px-8 py-4 text-[16px] font-semibold tracking-wide text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Apply to Join
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                    <Link
                        to="/how-it-works"
                        data-testid="prof-learn-how-it-works"
                        className="group inline-flex items-center gap-3 border border-white/25 px-8 py-4 text-[16px] font-medium tracking-wide text-white transition-colors duration-300 hover:border-accent hover:text-accent"
                    >
                        Learn How It Works
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                    <Link
                        to="/pro"
                        data-testid="prof-explore-pro"
                        className="group inline-flex items-center gap-3 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                    >
                        Explore BuildEase Pro
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    </section>
);

export default ProfClosing;
